// frontend/src/components/homepage/adHeroCopy.js
//
// The homepage hero's copy for visitors from the Google Search "buy leads" ad
// group (owner-approved wording, verbatim). Homepage.js spreads it into
// HeroLive only for a Hebrew visit whose acquisition code is
// AD_HERO_SOURCE_CODE, and only once hydrated - the prerender snapshot and
// every other visitor keep the default hero. Profession pages never read it.
//
// The trial length is DERIVED from the offline pricing mirror, never typed
// here (CLAUDE.md: every advertised plan number is derived). The code that
// picks this copy changes words only - never a price, a discount or a trial
// length (utils/adVisitor.js).

import { FREE_TRIAL_DAYS } from "../../contexts/PricingContext";

/** The `s` code of the "buy leads" ad group (gads-buy-leads), the homepage's. */
export const AD_HERO_SOURCE_CODE = "r8";

/**
 * HeroLive props for the ad-visitor hero. Stats, cards and the button's target
 * stay the default. `layout: "ad"` is the owner-approved arrangement for these
 * words: one CTA with the ticks under it, no login button, no micro line and no
 * glass behind the sub and the body (HeroLive.js).
 */
export const AD_HERO_COPY = Object.freeze({
  layout: "ad",
  line1: ["עדיין", "קונים", "לידים?"],
  line2: ["יש", "דרך", "חכמה", "יותר."],
  sub: "סוכני ה-AI שלנו קוראים ומנתחים את השיח בקבוצות פייסבוק באופן רציף, ומאתרים אנשים שמחפשים באופן פעיל וכותבים במפורש שהם צריכים בעל מקצוע כמוכם.",
  body: "הכל קורה ונשלח אליכם בזמן אמת, ואתם הראשונים לדעת מזה ולהגיב.",
  ticks: ["מחיר קבוע", "לא משלמים פר ליד", "עד מאות לידים בחודש"],
  primaryCta: `מתחילים ${FREE_TRIAL_DAYS} יום חינם`,
});
